import { useEffect, useState } from "react";
import { useIsMobile } from "@/hooks/useIsMobile";
import type { Invoice } from "@/lib/invoice.api";
import type {
  InvoicePaymentFilter,
  InvoiceStatusFilter,
  InvoiceViewMode,
} from "../invoice.constants";

export function useInvoicesPageState() {
  const [viewMode, setViewMode] = useState<InvoiceViewMode>("table");
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState<InvoiceStatusFilter>("all");
  const [paymentFilter, setPaymentFilter] = useState<InvoicePaymentFilter>("all");
  const [selectedInvoice, setSelectedInvoice] = useState<Invoice | null>(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile) setViewMode("grid");
  }, [isMobile]);

  function resetFilters() {
    setSearch("");
    setStatusFilter("all");
    setPaymentFilter("all");
  }

  return {
    viewMode,
    setViewMode,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    paymentFilter,
    setPaymentFilter,
    selectedInvoice,
    setSelectedInvoice,
    resetFilters,
  };
}
